import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react'
import { CMS_GRAPHQL_ENDPOINT } from 'config/constants'
import {
  ClientError,
  GraphQLClient,
  RequestOptions,
  Variables
} from 'graphql-request'
import { HYDRATE } from 'next-redux-wrapper'

/**
 * The base GraphQL API
 *
 * Endpoints are automatically generated from `.graphql` files.
 *
 * __Configuration__: `/codegen.yml`
 * @see [link](https://www.graphql-code-generator.com/plugins/typescript-rtk-query)
 */

export const client = new GraphQLClient('', {
  credentials: 'include',
  mode: 'cors',
})

const wpGraphQlBaseQuery =
  ({
    url,
  }: {
    url: string
  }): BaseQueryFn<
    RequestOptions<Variables>,
    { data: Record<string, unknown> },
    { status: number; data: ClientError | unknown }
  > =>
  async (requestOptions, { endpoint, getState, dispatch }, thing) => {
    client.setEndpoint(url)

    // console.log(endpoint, requestOptions.variables || {})

    try {

      const data = await client.request(requestOptions)

      return { data }
    } catch (error) {

      const err = { status: 500, data: `${error}` }

      if (error instanceof ClientError) {
        err.status = error.response.status;
        err.data = error.message
      }
      console.error(err);
      return { error: err }
    }
  }

const apiBase = createApi({
  reducerPath: 'wordpressApi',
  baseQuery: wpGraphQlBaseQuery({
    url: CMS_GRAPHQL_ENDPOINT || '',
  }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath]
    }
  },
  endpoints: (builder) => ({}),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

export { apiBase as api }

export default apiBase

// export endpoints for use in SSR
// export const { getCategories, getPostIndex, getPostBySlug, getPostList } = api.endpoints;
